import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import { Table } from 'react-bootstrap'
import { restrictSpecialChar, sortPortalPermissionByKey, isPermissionExist, isVehicleFieldEmpty } from '../../utils/helper'
import { Col, Row } from 'react-bootstrap'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import OversizedVehicleCheckbox from './OversizedVehicleCheckbox'
import { getVehicleModelList } from '../../redux/actions/VehicleListAction'
import { Circles } from 'react-loader-spinner'

function VehicleModal(props) {
    const { permitListData, isModalOpen, setModal, modalName, vehicleData, setVehicleData, handleSubmitVehicleData, submitButtonDisable, formError, setFormError, getVehicleList, dispatch, partnerDetails } = props //setMakeModelList
    const [error, setError] = useState(false)
    const [vehicleMakeList, setVehicleMakeList] = useState(EMPTY_ARRAY)
    const [vehicleModelList, setvehicleModelList] = useState(EMPTY_ARRAY)
    const [vehicleInputDataLists, setVehicleInputDataLists] = useState(EMPTY_ARRAY)
    const [accessPermissions, setAccessPermissions] = useState('')
    const [vehicleYearList, setVehicleYearList] = useState(EMPTY_ARRAY)

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        if (formError) {
            setError('this field is required.')
        } else {
            setError('')
        }
    }, [formError])

    useEffect(() => {
        getVehical()
    }, EMPTY_ARRAY)


    const getVehical = () => {
        dispatch(getVehicleModelList()).then((res) => {
            let makeList = res.make
            makeList.unshift({
                'id': 'Others',
                'name': 'Others',
                'mst_model': [{
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                }]
            })
            setVehicleYearList(res?.year?.length > 0 ? res?.year : EMPTY_ARRAY)
            setVehicleMakeList(makeList)
            setVehicleInputDataLists(res)
            // setMakeModelList(res?.make)
            // setValue('country', res.country[0].name)
            // if (BookingEdit) {
            // 	let model = (res?.make?.length > 0) && res?.make?.filter((v) => v?.name == BookingEditData?.vehical_details?.make)
            // 	setvehicleModelList(model[0]?.mst_model)
            // }

        })

    }

    const handleModalFieldsData = (e, i) => {
        const { name, value } = e.target
        if (name === 'is_oversized') {
            vehicleData[i][name] = e.target.checked
            setVehicleData([...vehicleData])
        } else if (name === 'license_plate' || name == 'modeltext' || name == 'state_id' || name == 'maketext' || name == 'year') {
            const vehicleList = vehicleData?.slice()
            vehicleList[i][name] = value
            setVehicleData(vehicleList)
        } else if (name == 'make') {
            let modelData = vehicleInputDataLists?.make?.filter((v) => v.id == value)
            let makeData = vehicleMakeList?.filter((v) => v.name == value)
            let modelList = modelData?.[0]?.mst_model
            let check = modelList?.some((value) => value?.name == 'Others')
            if (!check) {
                modelList?.unshift({
                    'id': 'Others',
                    'make_id': 'Others',
                    'name': 'Others'
                })
            }
            const newState = [...vehicleModelList]
            if (i < vehicleModelList.length) {
                newState[i] = modelData[0]?.mst_model
            } else {
                newState.push(modelData[0]?.mst_model)
            }
            setvehicleModelList(newState)
            vehicleData[i]['make_id'] = makeData?.[0]?.id != 'Others' ? makeData?.[0]?.id : 0
            vehicleData[i]['make_id'] = value
            vehicleData[i]['model_id'] = ''
            vehicleData[i]['make'] = value == 'Others' ? '' : makeData?.[0]?.name
            vehicleData[i]['maketext'] = value == 'Others' ? '' : value
            vehicleData[i]['othermake'] = (value == 'Others') ? true : false
            vehicleData[i]['othermodel'] = (value == 'Others') ? true : false
            vehicleData[i]['vehicleList'] = modelList
            setVehicleData([...vehicleData])
            setFormError(false)
        } else if (name == 'model') {
            // let filter = modeldata?.filter(model => model?.id == value)
            vehicleData[i]['othermodel'] = (value == 'Others') ? true : false
            vehicleData[i]['model_id'] = value
            // vehicleData[i]['model'] = (value != 'Others' && filter?.length > 0) ? filter?.[0]?.name : ''
            setVehicleData([...vehicleData])
        } else if (name == 'color_id') {
            // let filter = vehicleInputDataLists?.color?.filter(col => col?.id == value)
            vehicleData[i][name] = value
            // vehicleData[i]['color'] = filter?.[0]?.name
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])
        } else {
            vehicleData[i][name] = value
            setVehicleData([...vehicleData])
            setFormError(false)
        }
    }


    const addVehicleMake = () => {
        const payloadData = [...vehicleData]
        // checking the every object item is empty or not 
        const testToSeeAllErrorsAreEmpty = payloadData?.every((item) => item?.license_plate !== '')

        let checkpermitLinkemplty = true
        if (isPermissionExist(accessPermissions, 'Permit Link with Vehicle') && permitListData?.length > 0) {
            checkpermitLinkemplty = payloadData?.every(
                (val) => val?.permit_ids?.length > 0
            )
        }
        if (payloadData?.length <= (4 - getVehicleList?.length) && testToSeeAllErrorsAreEmpty === true) {
            const freeTextMakeModel = isPermissionExist(accessPermissions, 'Allow Free-Text Make & Model') ? true : false
            payloadData.push({ 'license_plate': '', 'make': '', 'make_id': freeTextMakeModel ? 'Others' : '', 'model': '', 'color': '', 'state_id': '', 'othermake': freeTextMakeModel, 'othermodel': freeTextMakeModel, 'vehicleList': [], 'permit_ids': [] })
            setVehicleData([...payloadData])
            setError('')
        } else if (testToSeeAllErrorsAreEmpty === false || checkpermitLinkemplty === false) {
            setError('License Plate is required!')
        } else {
            setError('Maximum 5 vehicles are allowed.')

        }
    }

    const isVehicleDetailsRequired = isPermissionExist(accessPermissions, 'Required Vehicle Details')
    const isOversizedVehicleEnabled = isPermissionExist(accessPermissions, 'Oversized Vehicle')
    const requiredMark = isVehicleDetailsRequired && <span className="text-danger">*</span>
    const requiredVehicleFieldError = (vehicleListItem, field) => (isVehicleDetailsRequired && formError && isVehicleFieldEmpty(vehicleListItem, field)) ? 'This field is required' : ''

    const removeVehicleMake = (e, i) => {
        const payloadData = [...vehicleData]
        payloadData?.splice(i, 1)
        setVehicleData([...payloadData])
        setError('')
    }

    return (
        <>
            <Modal
                size="xl"
                show={isModalOpen}
                onHide={() => setModal(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        {modalName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {vehicleData?.map((vehicleListItem, vehicleListIndex) => {
                        return (
                            <div className='bg-light border p-2 mb-2 position-relative' key={vehicleListIndex}>
                                <Row className='row g-2 row-cols-2  row-cols-sm-3 row-cols-md-4' >
                                    <Col className='mt-1'>
                                        <label className='form-label' >License Plate Number <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name='license_plate'
                                            required={true}
                                            className="form-control"
                                            placeholder="License Plate Number"
                                            maxLength={10}
                                            minLength={2}
                                            onKeyDown={restrictSpecialChar}
                                            value={vehicleListItem?.license_plate}
                                            onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                            aria-describedby="emailHelp" />
                                        <small className='text-danger'>{(error && vehicleListItem?.license_plate == '') ? error : (error && vehicleListItem?.license_plate?.length < 1) ? 'Minimum 1 characters allowed' : ''}</small>

                                    </Col >

                                    {/* MAKE */}
                                    {
                                        !isPermissionExist(accessPermissions, 'Allow Free-Text Make & Model') && <Col className='mt-1'>
                                            <label className='form-label' >Vehicle Make {requiredMark}</label>
                                            <select autoComplete="off" name="make" placeholder="Make" onKeyDown={restrictSpecialChar} className="form-select form-control" value={vehicleListItem?.make_id} id="make" onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                                <option value="">Select an option</option>
                                                {(vehicleMakeList?.length > 0) && vehicleMakeList?.map((val, index) => {
                                                    return (
                                                        <option value={val?.id} key={index} >{val?.name}</option>
                                                    )
                                                })}
                                            </select>
                                            {!vehicleListItem?.othermake && <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'make')}</small>}
                                        </Col>
                                    }

                                    {
                                        isPermissionExist(accessPermissions, 'Allow Free-Text Make & Model') || vehicleListItem?.othermake ? <Col className='mt-1'>
                                            <label className='form-label' >Make {requiredMark}</label>
                                            <input
                                                type="text"
                                                name='maketext'
                                                className="form-control"
                                                placeholder="Make"
                                                onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                                maxLength={15}
                                                minLength={4}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.maketext}
                                                aria-describedby="emailHelp" />
                                            <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'make')}</small>
                                        </Col> : ''
                                    }

                                    {/* MODAL */}
                                    {
                                        !vehicleListItem?.othermake && !isPermissionExist(accessPermissions, 'Allow Free-Text Make & Model') ? <Col className='mt-1'>
                                            <label className='form-label' >Vehicle Model {requiredMark}</label>
                                            <select className='form-select form-control' value={vehicleListItem?.model_id} placeholder="Model" name="model" id='state' onKeyDown={restrictSpecialChar} onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} disabled={vehicleListItem?.make_id ? false : true}>
                                                <option value="0">Select an option</option>
                                                {(vehicleModelList?.length > 0) && vehicleModelList?.[vehicleListIndex]?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.name}</option>)}
                                            </select>
                                            {!vehicleListItem?.othermodel && <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'model')}</small>}
                                        </Col> : ''
                                    }

                                    {
                                        isPermissionExist(accessPermissions, 'Allow Free-Text Make & Model') || (vehicleListItem?.othermake || vehicleListItem?.othermodel) ? <Col className='mt-1'>
                                            <label className='form-label' >Model {requiredMark}</label>
                                            <input
                                                type="text"
                                                name='modeltext'
                                                className="form-control"
                                                placeholder="Model"
                                                onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                                maxLength={15}
                                                minLength={4}
                                                onKeyDown={restrictSpecialChar}
                                                value={vehicleListItem?.modeltext}
                                                aria-describedby="emailHelp" />
                                            {vehicleListItem?.othermodel && <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'model')}</small>}
                                        </Col> : ''
                                    }

                                    {/* YEAR */}
                                    {
                                        !isPermissionExist(accessPermissions, 'Year') && <Col className='mt-1'>
                                            <label className='form-label' >Year {requiredMark}</label>
                                            <select
                                                name="year"
                                                autoComplete="off"
                                                className="form-select form-control"
                                                value={vehicleListItem?.year}
                                                id="year"
                                                onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                                onKeyDown={restrictSpecialChar}
                                            >
                                                <option value="0">Select an option</option>
                                                {vehicleYearList?.map((year) => (<option key={year} value={year}> {year}</option>))}
                                            </select>
                                            <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'year')}</small>
                                        </Col>
                                    }

                                    {
                                        isPermissionExist(accessPermissions, 'Year') &&
                                        <Col className='mt-1'>
                                            <label className='form-label' >Year {requiredMark}</label>
                                            <input
                                                type="text"
                                                name="year"
                                                className="form-control"
                                                placeholder="Year"
                                                maxLength={4}
                                                value={vehicleListItem?.year}
                                                onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                                onKeyDown={restrictSpecialChar}
                                                aria-describedby="year" />
                                            <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'year')}</small>
                                        </Col>
                                    }

                                    <Col className='mt-1'>
                                        <label className='form-label' >Color </label>
                                        <select name='color_id' autoComplete="off" className='form-select form-control' value={vehicleListItem?.color_id} placeholder="Color" id='color_id' onChange={(e) => handleModalFieldsData(e, vehicleListIndex)} onKeyDown={restrictSpecialChar}>
                                            <option value="">Select an option</option>
                                            {(vehicleInputDataLists?.color?.length > 0) && vehicleInputDataLists?.color?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.name}</option>)}
                                        </select>
                                        {/* <input
                                        type="text"
                                        name='color'
                                        className="form-control"
                                        placeholder="Color"
                                        onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                        maxLength={15}
                                        minLength={4}
                                        onKeyDown={restrictSpecialChar}
                                        value={vehicleListItem?.color}
                                        aria-describedby="emailHelp" /> */}
                                    </Col>
                                    <Col className='mt-1'>
                                        <label className='form-label' >State/Province of Registration {requiredMark}</label>
                                        <select className='form-select form-control' value={vehicleListItem?.state_id} placeholder="Model" name="state_id" id='state_id' onKeyDown={restrictSpecialChar} onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}>
                                            <option value="0">Select an option</option>
                                            {(vehicleInputDataLists?.state?.length > 0) && vehicleInputDataLists?.state?.map((item, itemIndex) => <option key={(itemIndex + 1)} value={item?.id}>{item?.state_code}</option>)}
                                        </select>
                                        <small className='text-danger'>{requiredVehicleFieldError(vehicleListItem, 'state')}</small>

                                    </Col>
                                    {isOversizedVehicleEnabled && <Col className='mt-1'>
                                        <OversizedVehicleCheckbox
                                            id={`modal_is_oversized_${vehicleListIndex}`}
                                            checked={vehicleListItem?.is_oversized}
                                            message={partnerDetails?.facilities[0]?.facility_configuration?.oversize_message}
                                            onChange={(e) => handleModalFieldsData(e, vehicleListIndex)}
                                        />
                                    </Col>}
                                </Row >

                                <Col xl="auto" className='top-0 right-0 position-absolute '>
                                    {(vehicleData && getVehicleList) ? vehicleData?.length - 1 === vehicleListIndex ?
                                        <button type="button" className="btn btn-primary btn-sm" disabled={vehicleData?.length > (4 - getVehicleList.length)} onClick={addVehicleMake}><i className="fa fa-plus"></i> </button> :
                                        vehicleListIndex !== -1 ? <button type="button" className="btn btn-danger btn-sm w-100" onClick={(e) => removeVehicleMake(e, vehicleListIndex)}><i className="fa fa-minus"></i></button> :
                                            null
                                        : null}
                                </Col>
                            </div >

                        )
                    })}
                </Modal.Body >
                <Modal.Footer>
                    <div className='row d-block w-100'>
                        <div className='d-flex align-items-end justify-content-end'>
                            <Button type="submit" data-bs-dismiss="modal" disabled={submitButtonDisable} onClick={handleSubmitVehicleData} style={{ float: 'right', marginTop: '5px' }}>
                                {submitButtonDisable ? <span className='ms-2 d-flex justify-content-center'>Submit  <Circles
                                    height="20"
                                    width="30"
                                    color="white"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></span> : 'Submit'}
                            </Button>
                        </div >
                        <div style={{ float: 'right' }} className='text-end'>
                            <small className='small'>License plate is required and should have 2 to 10 characters.</small>
                        </div>

                    </div >
                </Modal.Footer >
            </Modal >
        </>
    )
}

VehicleModal.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    modalName: PropTypes.string,
    vehicleData: PropTypes.array,
    setVehicleData: PropTypes.func,
    handleSubmitVehicleData: PropTypes.func,
    isModalOpen: PropTypes.bool,
    setModal: PropTypes.func,
    submitButtonDisable: PropTypes.bool,
    getVehicleList: PropTypes.array,
    formError: PropTypes.bool,
    setFormError: PropTypes.func,
    // setMakeModelList : PropTypes.array,
    permitListData: PropTypes.array,
    partnerDetails: PropTypes.object
}

VehicleModal.defaulProps = {
    dispatch: noop,
    loader: false,
    modalName: undefined,
    vehicleData: EMPTY_ARRAY,
    setVehicleData: noop,
    handleSubmitVehicleData: noop,
    isModalOpen: false,
    setModal: noop,
    formError: false,
    setFormError: noop,
    submitButtonDisable: false,
    getVehicleList: EMPTY_ARRAY,
    // setMakeModelList : EMPTY_ARRAY,
    permitListData: EMPTY_ARRAY,
    partnerDetails: {}
}

function mapStateToProps({ state }) {
    return { state }
}
export default connect(mapStateToProps)(VehicleModal)
